/* eslint-disable no-console */
import nsToken from '@netsapiens/netsapiens-js/dist/token';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import {
  call,
  put,
  take,
  race,
  delay,
} from 'redux-saga/effects';
import fetchAudioDevice from '../fetchAudioDevice.js/fetchAudioDevice';

import { getNavigate } from '../../services/router/router';
import { getDuplicateInstanceRoute } from '../../routePaths';

export default function* duplicateAudioDevice(devicePostFix, debug = false) {
  const navigate = yield call(getNavigate);
  const decodedToken = yield call(nsToken.getDecoded);

  try {
    yield put({ type: 'SIP_DEVICE_DUPLICATION_STARTED' });

    // Check SIP device registration status
    const sipDevice = yield call(fetchAudioDevice, devicePostFix);

    console.log('SIP Device status:', sipDevice);

    // If device is already registered, check for active calls
    if (sipDevice.mode === 'registered' || sipDevice.mode === 'registered_endpoint' || sipDevice.call_processing_rule === 'PUSH') {
      let activeCallRes;
      try {
        activeCallRes = yield call(nsApi.get, {
          object: 'call',
          action: 'read',
          domain: decodedToken.domain,
          user: decodedToken.user,
          format: 'json',
        });
        if (debug) console.debug('this is res active calls: ', activeCallRes);
      } catch (error) {
        console.warn('Failed to fetch active calls:', error);
        activeCallRes = null;
      }

      // Check if there are active calls
      const hasActiveCalls = activeCallRes && Array.isArray(activeCallRes) && activeCallRes.length > 0;

      // Navigate to duplicate instance route with active call information
      navigate(getDuplicateInstanceRoute(), {
        state: {
          sipDevice,
          hasActiveCalls,
        },
      });

      // Block saga execution and wait for user interaction with timeout
      const userAction = yield race({
        userDecision: take([
          'DUPLICATE_AUDIO_DEVICE_CONTINUE',
          'DUPLICATE_AUDIO_DEVICE_TRANSFER_AUDIO',
          'DUPLICATE_AUDIO_DEVICE_RETURN_LOGIN',
        ]),
        timeout: delay(300000), // 5 minute timeout
      });

      // Handle timeout
      if (userAction.timeout) {
        yield put({ type: 'SIP_DEVICE_DUPLICATION_TIMEOUT' });

        return {
          success: false,
          reason: 'TIMEOUT',
          data: { user: decodedToken.user, sipDevice, hasActiveCalls },
        };
      }

      const { userDecision } = userAction;

      // Handle user decision
      switch (userDecision.type) {
        case 'DUPLICATE_AUDIO_DEVICE_CONTINUE':

          return {
            success: true,
            reason: 'CONTINUE',
            data: {
              user: decodedToken.user,
              sipDevice,
              deviceUri: `sip:${decodedToken.user}${devicePostFix}@${decodedToken.domain}`,
              userPreferences: userDecision.payload,
              hasActiveCalls,
            },
          };

        case 'DUPLICATE_AUDIO_DEVICE_TRANSFER_AUDIO':

          return {
            success: true,
            reason: 'TRANSFER_AUDIO_HERE',
            data: {
              user: decodedToken.user,
              sipDevice,
              activeCallRes,
              hasActiveCalls,
            },
          };

        case 'DUPLICATE_AUDIO_DEVICE_RETURN_LOGIN':

          return {
            success: false,
            reason: 'RETURN_TO_LOGIN',
            data: null,
          };

        default:
          return {
            success: false,
            reason: 'UNKNOWN_ACTION',
            data: null,
          };
      }
    }

    // Device is unregistered - proceed with duplication flow
    return {
      success: true,
      reason: 'DEVICE_UNREGISTERED',
      data: { user: decodedToken.user, sipDevice },
    };
  } catch (error) {
    console.error('SIP device duplication error:', error);
    // bugsnagClient.notify(error); // Uncomment if using bugsnag

    return {
      success: false,
      reason: 'API_ERROR',
      error: error.message,
    };
  }
}
